$(() => {

  // Elements
  const $window = $(window);
  const $body = $("body");
  const $healthy = $("form#healthy", $body);

  if ($healthy.length > 0) {
    const $alert = $("#healthy-alert", $healthy);
    const $inputs = $("input", $healthy);

    // Set everything on unchecked on page reload
    $inputs.prop("checked", false);

    $inputs.change(event => {
      if ($inputs.filter("[value=1]:checked").length >= 3) {
        // show alert when three or more are checked

        $alert.show();
      } else {
        if ($inputs.filter(":checked").length === ($inputs.length / 2)) {
          // When all options have been checked / but only selected 1 or 2
          // times "Yes"
          $alert.show();
        } else {
          $alert.hide();
        }
      }
    });
  }

});


// WEBPACK FOOTER //
// ./js/healthy.js